import type { DocumentOcrRetakeReasonCodeValue } from '@repo/common';

import { useTranslation } from 'react-i18next';

const RETAKE_REASON_CODES: DocumentOcrRetakeReasonCodeValue[] = [
  'DOB_AGE_OUT_OF_RANGE',
  'DOE_DURATION_OUT_OF_RANGE',
  'DOI_AGE_OUT_OF_RANGE',
  'FIELD_LENGTH_MISMATCH',
  'INVALID_DOB',
  'INVALID_DOE',
  'INVALID_DOI',
  'LOW_OCR_CONFIDENCE',
  'MRZ_CHECKSUM',
  'MRZ_INCONSISTENT',
  'PORTRAIT_COVERED',
  'UNKNOWN',
];

function isKnownRetakeReason(code: string): code is DocumentOcrRetakeReasonCodeValue {
  return RETAKE_REASON_CODES.includes(code as DocumentOcrRetakeReasonCodeValue);
}

export function useDocumentOcrRetakeText(reasonCode: string): { subtitle: string; title: string; tryAgainButton: string } {
  const { t } = useTranslation();
  const code = isKnownRetakeReason(reasonCode) ? reasonCode : 'UNKNOWN';

  return {
    title: t(`steps.documentCapture.retake.${code}.title`),
    subtitle: t(`steps.documentCapture.retake.${code}.subtitle`),
    tryAgainButton: t('steps.documentCapture.retake.tryAgainButton'),
  };
}
